import React from 'react';
import { RichText } from '../RichText/RichText';
import { classNames } from '../../utils';
import { RichTextCodeProps } from './types';

import styles from './RichTextCode.module.scss';

import 'prismjs/themes/prism-okaidia.css';
import 'prismjs/plugins/toolbar/prism-toolbar.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/toolbar/prism-toolbar';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard';
import 'prismjs/components/prism-xml-doc';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-lua';

export const RichTextCode: React.FC<RichTextCodeProps> = ({
  html,
  className,
  id,
  analyticsConfig,
}) => {
  return (
    <RichText
      html={html}
      className={classNames(styles['rich-text-code'], className)}
      id={id}
      analyticsConfig={analyticsConfig}
    />
  );
};
